import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { pxToRem } from "@/util/common";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/redux/store";
import FixedNavBar from "@/components/fixedNavBar";
import { Image, InfiniteScroll, PullToRefresh, SearchBar } from "antd-mobile";
import { DownFill } from "antd-mobile-icons";
import useRouter from "@/hooks/useRouter";
import TinyChen from "@/components/tinyChen";
import API from "@/api";
import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import usePopup from "@/hooks/usePopup";
import SearchMembersList from "./comp/SearchMembersList";
import CustomEmpty from "@/components/Empty";
import { setUserManage } from "@/redux/reducers/manageUser";
import useCustomTranslation from "@/hooks/useTranslation";

const AddMembers: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { customNavigate, goBack } = useRouter();
	const dispatch: AppDispatch = useDispatch();
	const SearchMembersListPopup = usePopup();
	const [firstPage, setFirstPage] = useState(true);
	//  sort/默认根据创建时间倒序 1/根据余额排序
	const [bySortValue, setBySortValue] = useState(0);
	const bySortList = [
		{
			sort: 0,
			name: "SortByTime",
		},
		{
			sort: 1,
			name: "SortByBalance",
		},
	];

	const [value, setValue] = useState("");
	const [data, setData] = useState<any[]>([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);
	const pageSize = 40;
	const postFinanceAccountMemberSearchHandle = async (isRefresh = false) => {
		try {
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				page: pageNum,
				pageSize: pageSize,
				nickname: value,
				sort: bySortList[bySortValue].sort,
				agentRole: -1,
			};

			const result: any =
				await API.finances.apiFinanceAccountMemberSearch(params);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = result.content.haveMore;
				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setData(contentData);
				} else {
					setData((prevData) => [...prevData, ...contentData]);
				}
			}
		} catch (error) {
			console.log("---apiFinanceAccountMemberSearch--:", error);
		}
	};
	const handleRefresh = async () => {
		// 模拟刷新数据
		await postFinanceAccountMemberSearchHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await postFinanceAccountMemberSearchHandle();
	};

	useEffect(() => {
		postFinanceAccountMemberSearchHandle();
	}, []);

	const onSubmitHandle = (value: number) => {
		setBySortValue(value);
		SearchMembersListPopup.closePopup();
	};

	useEffect(() => {
		if (!firstPage) handleRefresh();
		setFirstPage(false);
	}, [bySortValue]);

	const userSelectHandle = (data: any) => {
		dispatch(setUserManage(data));
		goBack();
	};

	return (
		<div className="router-main">
			<FixedNavBar title={t("AddMembers")} />
			<div className={classes.searchNavWrap}>
				<div className="search">
					<SearchBar
						value={value}
						onChange={(val: string) => {
							setValue(val);
						}}
						onSearch={handleRefresh}
						placeholder={t("Search")}
						style={{
							fontSize: pxToRem(12),
							fontWeight: "400",
							color: "#FFFFFF",
							"--border-radius": pxToRem(40),
							"--height": pxToRem(36),
							"--background": "#1E212B",
							"--placeholder-color": "#868FA8",
						}}
						icon={
							<Image
								src={require("@/assets/images/icons/search.png")}
								width={22}
								height={22}
							/>
						}
					/>
				</div>
			</div>
			<div className={classes.searchFor}>
				<div
					onClick={() => customNavigate("/search-result")}
					className="AddMembers"
				>
					<span>{t("MembersList")}</span>
				</div>
				<div
					onClick={SearchMembersListPopup.showPopup}
					className="balance"
				>
					<span>{t(bySortList[bySortValue].name)}</span>
					<DownFill color="#5E71B7" fontSize={10} />
				</div>
			</div>
			<div className="router-view">
				<div className={classes.AddMembersWrap}>
					<PullToRefresh
						onRefresh={handleRefresh}
						canReleaseText={t("canReleaseText")}
						completeText={t("completeText")}
						pullingText={t("pullingText")}
						refreshingText={t("refreshingText")}
					>
						{data.length === 0 ? (
							<CustomEmpty />
						) : (
							data.map((item, index) => (
								<div
									onClick={() => userSelectHandle(item)}
									key={index}
								>
									<TinyChen
										key={index}
										data={item}
										isOperate={false}
										index={index}
									/>
								</div>
							))
						)}
						{data.length > 0 && (
							<InfiniteScroll
								loadMore={handleFetchMore}
								hasMore={hasMore}
							>
								<InfiniteScrollContent hasMore={hasMore} />
							</InfiniteScroll>
						)}
					</PullToRefresh>
				</div>
			</div>

			<SearchMembersListPopup.PopupComp
				visible={SearchMembersListPopup.visiblePopup}
				onClose={SearchMembersListPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					SearchMembersListPopup.closePopup();
				}}
			>
				<SearchMembersList
					onVisiblePopup={SearchMembersListPopup.closePopup}
					onSubmit={onSubmitHandle}
					data={bySortList}
				/>
			</SearchMembersListPopup.PopupComp>
		</div>
	);
};

export default AddMembers;

const useStyles = createUseStyles({
	AddMembersWrap: {
		display: "flex",
		flexDirection: "column",
		padding: {
			top: pxToRem(15),
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(30),
		},
	},
	searchNavWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(18),
		},
		borderBottom: "1px solid #2F3A62",
		"& .search": {
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(40),
			"--adm-color-background": "#1E212B",
			"& .adm-input-element": {
				"--color": "#FFFFFF",
			},
		},
	},
	searchFor: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: {
			top: pxToRem(10),
			bottom: pxToRem(10),
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"& .AddMembers": {
			display: "flex",
			alignItems: "center",
			color: "#FFFFFF",
			fontSize: pxToRem(16),
			fontWeight: "600",
			lineHeight: pxToRem(24),
			"& span": {
				paddingRight: pxToRem(8),
			},
		},
		"& .balance": {
			display: "flex",
			alignItems: "center",
			padding: {
				left: pxToRem(17),
				right: pxToRem(15),
			},
			width: pxToRem(160),
			height: pxToRem(36),
			borderRadius: pxToRem(40),
			border: "1px solid #2F3A62",
			"& span": {
				flex: 1,
				overflow: "hidden",
				fontSize: pxToRem(12),
				fontWeight: "400",
				color: "#FFFFFF",
			},
		},
	},
});
